import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../core/api-base-url';
import {
  CreateVehicleProfileRequest,
  VehicleCatalogMatchRequest,
  VehicleCatalogMatchResponse,
  VehicleProfile
} from './vehicle-profiles.model';

@Injectable({ providedIn: 'root' })
export class VehicleProfilesService {
  private readonly apiBaseUrl = `${API_BASE_URL}/api/vehicleprofiles`;

  constructor(private readonly http: HttpClient) {}

  getByOwner(ownerId: string, refreshToken?: number): Observable<VehicleProfile[]> {
    const normalizedOwnerId = ownerId.trim();
    let params = new HttpParams();
    if (refreshToken !== undefined) {
      params = params.set('_ts', refreshToken.toString());
    }

    return this.http.get<VehicleProfile[]>(`${this.apiBaseUrl}/owner/${encodeURIComponent(normalizedOwnerId)}`, {
      params
    });
  }

  create(request: CreateVehicleProfileRequest): Observable<VehicleProfile> {
    return this.http.post<VehicleProfile>(this.apiBaseUrl, request);
  }

  matchVehicle(request: VehicleCatalogMatchRequest): Observable<VehicleCatalogMatchResponse> {
    return this.http.post<VehicleCatalogMatchResponse>(`${this.apiBaseUrl}/match`, request);
  }

  delete(vehicleId: number, ownerId: string): Observable<void> {
    const params = new HttpParams().set('ownerId', ownerId.trim());
    return this.http.delete<void>(`${this.apiBaseUrl}/${vehicleId}`, { params });
  }
}
